import { render, staticRenderFns } from "./CertificationEditPage.vue?vue&type=template&id=38a065f5&scoped=true"
import script from "./CertificationEditPage.vue?vue&type=script&lang=js"
export * from "./CertificationEditPage.vue?vue&type=script&lang=js"
import style0 from "./CertificationEditPage.vue?vue&type=style&index=0&id=38a065f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a065f5",
  null
  
)

export default component.exports